
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/golfkentat",
      function () {
        return require("private-next-pages/golfkentat.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/golfkentat"])
      });
    }
  